<template>
  <div class="bg-wrap" style="position:relative;">
    <!-- <div class="left">
    <div class="bg-wrap" style="position:relative;">
        <div class="left">
      <img class="" src="../assets/img/login.png" alt="营客通" width="100%" height="100%">
    </div> -->
    <div class="main-cont-wrap">
      <!-- <div class="inner" v-if="false">
        <el-form :model="loginForm" ref="loginForm" label-position="left" label-width="0px"
        style="width:528px;height:500px;">
          <div class="bd-b mgb20 pdl28 pdr28">
            <span class="bigTitle">营客通ERP系统</span>
          </div>
          <div class="mb-16 pdl28 pdr28">
            <img style="width:14px;height: 14px;margin-right:10px; " src="../assets/img/user.png" alt="">
            <span class="subTitle">用户名</span>
          </div>
          <div class="pdl28 pdr28">
            <el-input class="input_style" v-model="loginForm.account" name="pwd" placeholder="请输入用户名" type="text">
            </el-input>
          </div>
          <div class="mb-16 mt_16 pdl28 pdr28">
            <img style="width:14px;height: 14px;margin-right:10px; " src="../assets/img/pwd.png" alt="">
            <span class="subTitle">密码</span>
          </div>
          <div class="pdl28 pdr28">
            <el-input v-model="loginForm.checkPass" id="password" show-password name="pwd" placeholder="请输入密码"
              type="password">
            </el-input>
          </div>
          <div class="ui-form-btn pdl28 pdr28">
            <el-button style="width: 472px;
    height: 74px;
    background: #3B6FFA;
    border-radius: 10px;" type="primary" :loading="logining" @click="loginSubmit">
              {{ loginStr }}
            </el-button>
          </div>
          <div class="tool-box pdl28 pdr28">
            <div>
              <el-checkbox v-model="checked" class="remember">记住密码</el-checkbox>
            </div>
            <div class="register" @click="registerFun">申请入驻</div>
          </div>
          <div class="msg-box">
            <div id="messageBox" class="text"></div>
          </div>

        </el-form>
        <div class="pdl28 pdr28">
          <el-checkbox v-model="isAgree"></el-checkbox>
          <a style="text-decoration: none;
        color: rgb(0, 0, 0);
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #191919;
        font-size: 14px;
        margin-left: 8px;text-decoration: none; color: #000" href="#" @click="agree">《同意集市入驻服务协议》</a>
        </div>
      </div> -->
      <div class="settle-box">
        <div class="title g-mb20">{{ isRegister ? '入驻营客通' : '营客通ERP系统' }}</div>
        <div class="pdl28 pdr28">
          <div class="g-mb20" v-if="isRegister">
            <div class="input-box g-mb20">
              <el-input placeholder="请输入手机号码" auto-complete="new-password"
                v-model="registerData.contactPhone"></el-input>
            </div>
            <div class="input-box flex-wrap g-mb20 pdr15">
              <el-input placeholder="请输入验证码" auto-complete="new-password" v-model="registerData.valideCode"></el-input>
              <el-button type="text" @click="codeFun(59)">{{ codeOrCountdown }}</el-button>
            </div>
          </div>
          <div class="g-mb20" v-else>
            <div class="input-box g-mb20">
              <el-input v-model="loginForm.account" name="pwd" placeholder="用户名" type="text">
              </el-input>
            </div>
            <div class="input-box">
              <el-input v-model="loginForm.checkPass" id="password" show-password name="pwd" placeholder="密码"
                type="password">
              </el-input>
            </div>
          </div>
          <div class="btn-box g-mb20">
            <el-button v-if="isRegister" style="width: 500px;height: 74px;background: #3B6FFA;border-radius: 10px;"
              type="primary" @click="registerSubmit">
              {{ viewProgress ? '立即查看' : '立即入驻' }}
            </el-button>
            <el-button v-else style="width: 500px;height: 74px;background: #3B6FFA;border-radius: 10px;" type="primary"
              :loading="logining" @click="loginSubmitCheck">
              {{ loginStr }}
            </el-button>
          </div>
          <div v-if="isRegister">
            <div class="flex-wrap flex-sb">
              <div v-if="viewProgress">
                <span class="">还没有入驻？</span>
                <el-button type="text" @click="viewProgress = false">立即入驻</el-button>
              </div>
              <div v-else>
                <span class="">已提交入驻信息？</span>
                <el-button type="text" @click="viewProgress = true">查看进度</el-button>
              </div>
              <div>
                <span class="">已有账号？</span>
                <el-button type="text" @click="logoNow">立即登录</el-button>
              </div>
            </div>
            <div>
              <a style="color:#409EFF;" href="http://admin.ksaxshop.com/SupplierRegister/EntryProcess"
                target="_blank">入驻流程</a>
              <a style="color:#409EFF;" class="mgl20" href="http://admin.ksaxshop.com/SupplierRegister/EntryIntroduce"
                target="_blank">入驻介绍</a>
            </div>
          </div>
          <div class="" v-else>
            <div class="tool-box">
              <div>
                <el-checkbox v-model="checked" class="remember">记住密码</el-checkbox>
              </div>
              <div class="register" @click="registerFun">申请入驻</div>
            </div>
            <div class="">
              <el-checkbox v-model="isAgree"></el-checkbox>
              <a style="text-decoration: none;
            color: rgb(0, 0, 0);
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #191919;
            font-size: 14px;
            margin-left: 8px;text-decoration: none; color: #000" href="#" @click="agree">同意《营客通自营供应商注册服务协议》</a>
            </div>
          </div>
        </div>
        <div class="msg-box">
          <div id="messageBox" class="text"></div>
        </div>
      </div>
    </div>
    <div style="position: absolute;left: 0; bottom: 0;display:flex;justify-content:center;width: 100%;">
      <div style="width:70%; display: flex;justify-content:space-between;height:35px;line-height:35px;">
        <!--                    <span class="setAStyle"><a href="https://beian.miit.gov.cn/">沪ICP备20008483号</a></span>-->
        <el-link type="primary" :underline="false" href="https://beian.miit.gov.cn/">沪公网安备31011002005044号</el-link>
        <el-link :underline="false">上海赢可通信息科技有限公司版权所有 Copyright @2015-2021</el-link>
        <el-link type="primary" href="https://beian.miit.gov.cn/">沪ICP备20008483号</el-link>
      </div>
    </div>
    <el-dialog class="loginSubmitCheck" title="提示" :visible.sync="loginSubmitCheckVisible" width="70%">
      <p>尊敬的集市供应商:</p>
      <p>
        &nbsp;&nbsp;&nbsp;&nbsp;为了更好的服务集市供应商和下游商户，近期平台即将上线银行分账系统，此分账系统手续费为0.5%.因此自2023年8月10日起，在平台服务费用1%的基础上，加收0.5%的分账手续费，合计1.5%。平台服务费+分账手续费将在货款结算中直接予以扣除。
      </p>
      <p>感谢您的理解与支持。</p>
      <p class="textR">集市平台</p>
      <p class="textR">2023年8月10日</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="loginSubmitCheckVisible = false">取 消</el-button>
        <el-button type="primary" @click="loginSubmit">同 意</el-button>
      </span>
    </el-dialog>
    <!-- 入驻协议 -->
    <residential-agreement :account="loginForm.account" ref="residentialAgreement" @right="right"/>
  </div>
</template>
<script>
import {
  GetTenantId,
  Authenticate,
  GetUserDetail,
  GetUserMenu, TenantGetTenantDetail,
  AddSupplierSettled,
  ViewProgress,
  MobileVerifyCode
} from "../api/api";
import router from "@/router";
import { filterAsyncRouter } from "@/router/index";
import ResidentialAgreement from "@/components/residentialAgreement.vue";

const Base64 = require("js-base64").Base64;
export default {
  components: { ResidentialAgreement },
  data() {
    return {
      loginStr: "立即登录",
      logining: false,
      loginForm: {
        account: "",
        checkPass: ""
      },
      checked: false,
      isAgree: false,
      isRegister: false,
      viewProgress: false,
      codeOrCountdown: '发送验证码',
      registerData: {
        contactPhone: null,
        valideCode: null
      },
      loginSubmitCheckVisible: false,
      tableData: [
        {
          a: "退货",
          b: "营客通平台买家签收后满足七天无理由退货条件（包装完整、配件齐全、未经安装）",
          c: "退回产生的费用由营客通平台按正向配送价格承担"
        }, {
          a: "换货",
          b: "外包装完好（包括且不限于外包装无破损，无水渍，无油污，无明显凹陷），营客通平台签收后产品外观有损坏或出现质量问题无法正常使用，且营客通平台买家签收后15天内",
          c: "换货产生的所有费用由您承担"
        }
      ]
    };
  },
  created() {
    const data = window.localStorage.getItem("remember");
    if (data) {
      const wordData = JSON.parse(Base64.decode(data));
      this.loginForm.account = wordData.account;
      this.loginForm.checkPass = wordData.checkPass;
      this.checked = wordData.checked;
    }
  },
  methods: {
    codeFun(time) {
      let data = {
        mobile: this.registerData.contactPhone,
        codeType: 50
      }
      MobileVerifyCode(data).then(res => {
        if (res.data.success) {
          this.codeOrCountdown = '60s'
          let itme = time
          this.timer = setInterval(() => {
            if (itme > 0 && itme <= time) {
              this.codeOrCountdown = itme-- + 's'
            } else {
              this.codeOrCountdown = '发送验证码'
              clearInterval(this.timer)
              this.timer = null
            }
          }, 1000)
        } else {
          this.$message.error(res.data.message)
        }
      })

    },
    right() {
      this.isAgree = true
    },
    agree() {
      this.$refs.residentialAgreement.show()
      console.log('agree')
    },
    registerSubmit() {
      let el = document.getElementById('messageBox');
      if (!this.registerData.contactPhone) {
        el.style.display = "block";
        el.innerHTML = "请输入手机号！";
        return false;
      }
      if (!RegExp(/^1(3\d|4[5-9]|5[0-35-9]|6[2567]|7[0-8]|8\d|9[0-35-9])\d{8}$/).test(this.registerData.contactPhone)) {
        el.style.display = "block";
        el.innerHTML = "请输入正确手机号！";
        return false;
      }
      if (!this.registerData.valideCode) {
        el.style.display = "block";
        el.innerHTML = "请输入验证码！";
        return false;
      }
      el.style.display = "none";
      el.innerHTML = "";
      if (this.viewProgress) {
        let data = {
          mobile: this.registerData.contactPhone,
          verifyCode: this.registerData.valideCode
        }
        ViewProgress(data).then(res => {
          if (res.data.success) {
            let progress = res.data.data.response.progress
            window.open(`http://admin.ksaxshop.com/SupplierRegister/Progress?step=${progress}`, "_blank")
          } else {
            this.$message.error(res.data.message)
          }
        })
      } else {
        AddSupplierSettled(this.registerData).then(res => {
          if (res.data == 0) {
            this.$message.error('验证码不正确！')
          } else {
            window.open(`http://admin.ksaxshop.com/SupplierRegister/Register/EnterpriseInfo?phone=${this.registerData.contactPhone}`, "_blank")
          }
          //   console.log(res,'res')
          //   if (res.data.success) {
          //     if (this.viewProgress) {
          //       window.open("http://127.0.0.1:2366/SupplierRegister/Progress?step=0", "_blank")
          //     } else {
          //       // window.open("http://admin.ksaxshop.com/SupplierRegister/Register/EnterpriseInfo", "_blank")

          //     }
          //   } else {
          //     this.$message.error(res.data.msg)
          //   }
        })
      }
    },
    loginSubmitCheck() {
      console.log('submit')
      if (!this.isAgree) return this.$message.error('请勾选供应商入驻协议')
      // 登录之前清空token
      this.$store.commit("saveToken", null);
      window.localStorage.removeItem("Token");

      let el = document.getElementById('messageBox');
      if (this.loginForm.account == "") {
        el.style.display = "block";
        el.innerHTML = "请输入用户名！";
        return false;
      }
      if (this.loginForm.checkPass == "") {
        el.style.display = "block";
        el.innerHTML = "请输入密码！";
        return false;
      }
      el.style.display = "none";
      el.innerHTML = "";
      // this.loginSubmitCheckVisible = true
      this.loginSubmit()
    },
    loginSubmit() {
      // this.loginSubmitCheckVisible = false
      this.$store.commit("saveTenantId", null);
      let loginParams = {
        userNameOrEmailAddress: this.loginForm.account,
        password: this.loginForm.checkPass,
        rememberClient: this.checked
      };
      if (RegExp(/@/).test(this.loginForm.account)) {
        let index = this.loginForm.account.indexOf('@');
        let telantName = null;
        let userName = null;
        telantName = this.loginForm.account.substring(index + 1, this.loginForm.account.length);
        userName = this.loginForm.account.substring(0, index);
        this.logining = true;
        this.loginStr = "登录中...";
        let that = this;
        GetTenantId({ tenancyName: telantName }).then((res) => {
          that.logining = false;
          if (res.data.success) {
            if (res.data.result.tenantId == null) {
              that.loginStr = "重新登录";
              return this.$message.error('租户名不正确');

            }
            that.$store.commit("saveTenantId", res.data.result.tenantId);
            loginParams.userNameOrEmailAddress = userName;
            that.loginFun(loginParams);
          } else {
            that.$message.error(res.data.error.message);
            that.loginStr = "重新登录";
          }
        }).catch((res) => {
          that.$message({
            message: "认证失败",
            type: "error",
          });
          that.logining = false;
          that.loginStr = "重新登录";
        });
      } else {
        this.loginFun(loginParams);
      }
    },
    loginFun(loginParams) {
      let that = this;
      that.logining = true;
      Authenticate(loginParams).then((res) => {
        that.logining = false;
        if (!res.data.success) {
          this.$message.error(res.data.error.message);
          that.loginStr = "重新登录";
        } else {
          if (res.data.result.tenantId) {
            that.$store.commit("saveTenantId", res.data.result.tenantId);
          }
          var token = res.data.result.accessToken;
          that.$store.commit("saveToken", token);
          var curTime = new Date();
          var expiredate = new Date(
            curTime.setSeconds(
              curTime.getSeconds() + res.data.result.expireInSeconds
            )
          );
          that.$store.commit("saveTokenExpire", expiredate);
          window.localStorage.refreshtime = expiredate;
          window.localStorage.expires_in = res.data.result.expireInSeconds;
          that.getUserDetail(res.data.result.userId, token);
          // 租主 不调用 此接口
          // 租户 调用此接口
          // 根据 telentId 调接口  租主无 telentId
          if (this.$store.state.tenantId) {
            that.getTalentInfo();
          }

        }
      })
    },
    // 获取租户详情的 公司名称  用于登录后左上角的展示
    getTalentInfo() {
      // console.log('tenantId', this.$store.state.tenantId)
      let id = this.$store.state.tenantId;
      TenantGetTenantDetail({ Id: id }).then((res) => {
        // console.log('租户详情', res);
        if (res.data.success) {
          this.$store.commit('setTalentName', res.data.result)
        } else {
          this.$message.error(res.data.error.message || '获取租户详情失败, 请重试');
        }
      });
    },
    getUserDetail(userId, token) {
      let that = this;
      that.logining = true;
      GetUserDetail({ Id: userId }).then((res) => {
        that.logining = false;
        if (res.data.success) {
          // console.log('data**********', res.data.result)
          window.localStorage.contractCode = res.data.result.contractCode;
          window.localStorage.user = JSON.stringify(res.data.result);
          that.$store.commit('setIsSignIn1', res.data.result)
          that.getMenuList(token);
        } else {
          this.$message.error(res.data.error.message);
        }
      });
    },
    getMenuList(token) {
      var that = this;
      that.logining = true;
      GetUserMenu().then((res) => {
        that.logining = false;
        if (!res.data.success) {
          that.$message({
            message: res.data.error.message,
            type: "error",
          });
        } else {
          let items = res.data.result.items;
          that.GetNavigationBar(items);
          that.$store.commit('setIsSignIn', true)
        }
      });
    },
    // 获取路由树
    GetNavigationBar(items) {
      var _this = this;
      let getRouter = items; //后台拿到路由
      if (getRouter.length > 0) {
        getRouter = filterAsyncRouter(getRouter); //过滤路由
        window.localStorage.router = JSON.stringify(getRouter);
        router.$addRoutes(getRouter); //动态添加路由
      }
      _this.$router.replace(
        _this.$route.query.redirect ? _this.$route.query.redirect : "/"
      );
      if (_this.checked) {
        let data = {
          account: _this.loginForm.account,
          checkPass: _this.loginForm.checkPass,
          checked: _this.checked,
        };
        localStorage.setItem(
          "remember",
          Base64.encode(JSON.stringify(data))
        );
      } else {
        localStorage.removeItem("remember");
      }
    },
    logoNow() {
      this.isRegister = false
      this.viewProgress = false
    },
    registerFun() {
      this.viewProgress = false
      this.$router.push('/register')
      // this.isRegister = true
      // window.open("http://admin.ksaxshop.com/SupplierRegister/Index", "_blank")
    }
  },
};
</script>
<style scoped>
.bg-wrap /deep/ .el-input__inner {
  /*width: 270px;*/
  /*height: 23px;*/
  /*line-height: 23px;*/
  /*border: 0;*/
  /*outline: 0;*/
  /*padding: 0;*/
  /*color: #595961;*/
  /*font-size: 13px;*/
  /*background-color: transparent;*/
  /*width: 472px;*/
  border: none;
  height: 62px;
  width: 100%;
  height: 62px;
  line-height: 62px;
  background: #F7F8FA;
}

.bg-wrap /deep/ .el-input__inner::placeholder {
  /*padding-left: 0;*/
  /*color: #b6b7bf;*/
  /*font-size: 12px;*/
  /*width: 136px;*/
  height: 62px;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #BBBBBB;
  line-height: 62px;
}
</style>
<style scoped>
.table2 table,
table tr th,
table tr td {
  text-align: center;
  border: 1px solid #ccc;
}

.table2 table {
  width: 600px;
  border-collapse: collapse;
}

.table1 table,
table tr th,
table tr td {
  text-align: center;
  border: 1px solid #ccc;
}

.table1 table {
  width: 600px;
  border-collapse: collapse;
}

.table3 table,
table tr th,
table tr td {
  text-align: center;
  border: 1px solid #ccc;
}

.table3 table {
  width: 600px;
  border-collapse: collapse;
}

/* * {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
} */

.bg-wrap {
  position: relative;
  height: 100%;
  /* display: flex; */
  background: url(../assets/img/login_bg.png) top left no-repeat;
  background-size: 100% 100%;
  /*background-size: cover;
  /*flex-direction: column;*/
  /*justify-content: center;*/
  /*align-items: center;*/
  /*padding-bottom: 30px;*/
  /*min-height: 100vh;*/
  /*background: url(../assets/img/login_bg.png) top left no-repeat;*/
  /*background-size: cover;*/
  /*font-family: "Microsoft YaHei","微软雅黑",Arial,sans-serif;*/
}

.bg-wrap img {
  border: 0;
  -ms-interpolation-mode: bicubic;
  vertical-align: middle;
}

.logo-box {
  /*width: 340px;*/
  /*padding: 15px 0;*/
  /*display: flex;*/
  /*justify-content: center;*/
}

.main-cont-wrap {
  padding: 28px 0;
  background: #fff;
  /* width: 750px; */
  border-radius: 12px;
  position: absolute;
  right: 6%;
  top: 15%;
  /* display: flex;
  flex: 1;
  justify-content: center;
  align-items: center; */
  /*padding: 35px 35px 30px;*/
  /*background: #f7f8fc;*/
  /*box-shadow: 0 20px 30px 0 rgb(63 63 65 / 6%);*/
  /*border-radius: 10px;*/
}

.title {
  font-size: 21px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #1E2E3F;
  border-bottom: 1px solid #D5DBE5;
  padding-bottom: 20px;
  padding-left: 30px;
}

.input-box {
  background: #F7F8FA;
  width: 500px;
  overflow: hidden;
  border-radius: 10px;
  border: 1px solid #F7F8FA;
}

.ui-form-txt {
  /*display: inline-block;*/
  /*width: 70px;*/
  /*color: #595961;*/
  /*font-size: 13px;*/
}

.ui-form-item {
  position: relative;
  height: 30px;
  line-height: 30px;
  border-bottom: 1px solid #e3e3e3;
  box-sizing: border-box;
}

.ui-form-btn {
  margin-top: 40px;
  margin-bottom: 40px;
}

.ui-button {
  display: block;
  width: 270px;
  height: 40px;
  text-align: center;
  color: #fff;
  background: #2589ff;
  border-radius: 6px;
  font-size: 16px;
  border: 0;
  outline: 0;
}

.pdl28 {
  padding-left: 28px;
}

.pdr28 {
  padding-right: 28px;
}

.pdr15 {
  padding-right: 15px;
}

.flex-wrap {
  display: flex;
}

.flex-sb {
  justify-content: space-between;
}

.sub {
  flex: 1;
}

.g-mr20 {
  margin-right: 20px;
}

.g-ml10 {
  margin-left: 10px;
}

.g-mb10 {
  margin-bottom: 10px;
}

.g-mb20 {
  margin-bottom: 20px;
}

.g-mb25 {
  margin-bottom: 25px;
}

.g-mb30 {
  margin-bottom: 30px;
}

.g-mb40 {
  margin-bottom: 40px;
}

.s-fs16 {
  font-size: 16px;
}

.s-fs20 {
  font-size: 20px;
}

.cl0 {
  color: #000;
}

.s-fc-1f {
  color: #1f2026;
}

.s-fwb-600 {
  font-weight: 600;
}

.s-fwb-700 {
  font-weight: 700;
}

.pointer {
  cursor: pointer;
}

.msg-box {
  width: 270px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.msg-box .text {
  color: #ff5050;
  font-size: 12px;
  display: none;
}

.tool-box {
  width: 472px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
}

.tool-box .register {
  display: flex;
  align-items: flex-end;
  cursor: pointer;

  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #3B70FA;
}

.tool-box .remember {
  width: 64px;
  height: 16px;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #191919;
  line-height: 16px;
}

/* 覆盖谷歌浏览器自动填充登录输入框样式 */
/* Change the white to any color*/
/*input:-webkit-autofill,*/
/*input:-webkit-autofill:hover,*/
/*input:-webkit-autofill:focus,*/
/*input:-webkit-autofill:active {*/
/*  -webkit-box-shadow: 0 0 0 30px #f7f8fc inset !important;*/
/*}*/

/*Change text in autofill textbox*/
/*input:-webkit-autofill {*/
/*  -webkit-text-fill-color: #595961 !important;*/
/*}*/

.content-az {
  padding: 0 !important;
  border: none !important;
  overflow-y: hidden !important;
}

.left {
  height: 100vh;
  width: 50%;
}

.inner {
  /*display:flex;*/
  /*justify-content: center;*/
  /*align-items: center;*/
}

.input_style {
  /*width: 472px;*/
  /*height: 62px;*/
  /*border-radius: 10px;*/
  /*border: 1px solid #D5DBE5;*/
}

.subTitle {
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #191919;
  margin-bottom: 16px;
}

.mb-16 {
  margin-bottom: 16px;
}

.mt_16 {
  margin-top: 16px;
}

.bd-b {
  border-bottom: 1px solid #D5DBE5;
}

.mrb20 {
  margin-bottom: 20px;
}

.bigTitle {
  display: inline-block;
  width: 256px;
  height: 32px;
  font-size: 32px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #191919;
  line-height: 32px;
  margin-bottom: 20px;
}

.el-icon-view {
  margin-right: 60px;
}

.ui-form-btn span {
  font-size: 20px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
}

.scrolling ::-webkit-scrollbar {
  width: 4px;
}

.scrolling ::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: rgba(0, 0, 0, 0.2);
}

.scrolling ::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);
}

.setAStyle a {
  text-decoration: none;
}

.setAStyle a:hover,
a:visited,
a:link,
a:active {
  color: #333;
}

.textR {
  text-align: right;
}

.loginSubmitCheck>>>p {
  margin-top: 10px;
}

.xy p {
  margin-top: 10px;
}
</style>
